import { render, staticRenderFns } from "./OfferListTableDetails.vue?vue&type=template&id=44433770&scoped=true"
import script from "./OfferListTableDetails.vue?vue&type=script&lang=js"
export * from "./OfferListTableDetails.vue?vue&type=script&lang=js"
import style0 from "./OfferListTableDetails.vue?vue&type=style&index=0&id=44433770&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44433770",
  null
  
)

export default component.exports